import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@src/app/shared/guards/auth.guard';
import { ProfileGuard } from '@src/app/shared/guards/profile.guard';
import { MemeDashboardComponent } from './meme-dashboard.component';
import { DashboardHomeComponent } from './pages/dashboard-home/dashboard-home.component';
import { MyWatchlistComponent } from './pages/my-watchlist/my-watchlist.component';
import { TokenDetailComponent } from './pages/token-detail/token-detail.component';
import { WatchlistDetailComponent } from './pages/watchlist-detail/watchlist-detail.component';
import { WatchlistMarketplaceComponent } from './pages/watchlist-marketplace/watchlist-marketplace.component';

const routes: Routes = [
    {
        path: '',
        component: MemeDashboardComponent,
        title: 'Meme Dashboard',
        children: [
            {
                path: '',
                component: DashboardHomeComponent,
                pathMatch: 'full',
            },
            {
                path: 'token/:chain_name/:address',
                component: TokenDetailComponent,
            },

            {
                path: 'holder/:address',
                redirectTo: '/meme-dashboard', // 移除 holder detail，重定向到 dashboard
            },

            {
                path: 'watchlist-marketplace',
                children: [
                    {
                        path: '',
                        component: WatchlistMarketplaceComponent,
                        pathMatch: 'full',
                    },
                    {
                        path: ':watchlist_id',
                        canActivate: [() => inject(AuthGuard).canActivate(), () => inject(ProfileGuard).canActivate()],
                        component: WatchlistDetailComponent,
                    },
                ],
            },

            {
                path: 'my-watchlist',
                component: MyWatchlistComponent,
                canActivate: [() => inject(AuthGuard).canActivate()],
            },
            {
                path: '**',
                redirectTo: '/meme-dashboard',
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class MemeDashboardRoutingModule {}
